import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import TableSelectField from "./TableSelectField";

export const monthlist = [
  { id: 1, month: "Jan" },
  { id: 2, month: "Feb" },
  { id: 3, month: "Mar" },
  { id: 4, month: "Apr" },
  { id: 5, month: "May" },
  { id: 6, month: "Jun" },
  { id: 7, month: "Jul" },
  { id: 8, month: "Aug" },
  { id: 9, month: "Sep" },
  { id: 10, month: "Oct" },
  { id: 11, month: "Nov" },
  { id: 12, month: "Dec" },
];
const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth(); // Current month (0-based, January = 0)
const startYear = currentYear - 5; // 5 years ago from the current year
const years = Array.from({ length: 6 }, (_, i) => startYear + i); // 6 years range (from 5 years ago to the current year)
const CardMonthYearPicker = ({
  title,
  setSelectedMonth,
  setSelectedYear,
  selectedMonth,
  errors,
  setErrors,
  selectedYear,
  defaultMonth,
  defaultYear,
  width,
  gap,
}) => {
  const [filteredYears, setFilteredYears] = useState(years);
  const [disableValue, setDisableValue] = useState("");
  const [filteredMonths, setFilteredMonths] = useState(monthlist);

  useEffect(() => {
    setSelectedMonth(defaultMonth || currentMonth + 1);
    setSelectedYear(defaultYear || currentYear);
    if ((defaultYear || currentYear) === currentYear) {
      setFilteredMonths(monthlist.filter((m) => m.id <= currentMonth + 1));
    }
  }, [defaultMonth, defaultYear]);

  const handleMonthChange = (event) => {
    setErrors && setErrors({ ...errors, month: "" });
    const selectedMonthIndex = Number(event.target.value);
    setSelectedMonth(selectedMonthIndex);
    
    // Only disable current year if:
    // 1. Selected month is in the future (greater than current month)
    // 2. AND selected year is the current year
    if (selectedMonthIndex > currentMonth + 1 && Number(selectedYear) === currentYear) {
      setDisableValue(currentYear);
    } else {
      // Clear disableValue when month is valid or year is not current year
      setDisableValue("");
    }
  };

  const handleYearChange = (event) => {
    const selected = event.target.value;
    setErrors && setErrors({ ...errors, year: "" });
    setSelectedYear(selected);

    // Clear disableValue when year changes
    setDisableValue("");

    if (Number(selected) === currentYear) {
      const allowedMonths = monthlist.filter(
        (month) => month.id <= currentMonth + 1
      );
      setFilteredMonths(allowedMonths);

      if (!allowedMonths.some((month) => month.id === Number(selectedMonth))) {
        setSelectedMonth("");
      }
      
      // If selected month is in the future, disable current year
      if (Number(selectedMonth) > currentMonth + 1) {
        setDisableValue(currentYear);
      }
    } else {
      setFilteredMonths(monthlist);
      // For past years, clear disableValue
      setDisableValue("");
    }
  };

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
          {title}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: gap || 2 }}>
        <Box sx={{ width: width ? width : "75px" }}>
          <TableSelectField
            value={selectedMonth === 0 ? "0" : selectedMonth}
            handleChange={handleMonthChange}
            label="Month"
            field="month"
            errors={errors?.["month"] || ""}
            defaultValue={"Month"}
            options={filteredMonths}
          />
        </Box>

        {/* Year Input */}
        <Box sx={{ width: width ? width : "75px", height: "20px" }}>
          <TableSelectField
            value={selectedYear}
            handleChange={handleYearChange}
            options={filteredYears}
            errors={errors?.["year"] || ""}
            defaultValue={"Year"}
            disable={disableValue}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CardMonthYearPicker;
